// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleEditor = {
  id: "editor",
  mrn: "//iam.api.mondoo.app/roles/editor",
  title: "Editor",
  allowedActions,
} as const;

export type RoleEditor = typeof roleEditor;
